import { render } from "./SimpleKeyboard.vue?vue&type=template&id=31abc16e&scoped=true"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=js"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=js"

import "./SimpleKeyboard.vue?vue&type=style&index=0&id=31abc16e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31abc16e"]])

export default __exports__